import { render } from "./InviteRequestPage.vue?vue&type=template&id=1c597800&scoped=true"
import script from "./InviteRequestPage.vue?vue&type=script&lang=js"
export * from "./InviteRequestPage.vue?vue&type=script&lang=js"

import "./InviteRequestPage.vue?vue&type=style&index=0&id=1c597800&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c597800"]])

export default __exports__